import { createStore } from "vuex";
import { auth } from "../AuthenticationService/AuthenticationManager";
const store = createStore({
  modules: {
    auth,
  },
});
export default store;